import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default (url: string | undefined): string => {
    const origin = getUmbracoEndPoint();

    if (!url) {
        return "";
    }

    url = url
        .toString()
        .replace(origin, "")
        .replace("http://localhost:3000", "")
        .replace("https://stage.easyfood.frontend.heyday.dk", "")
        .replace("http://easyfood.heyday.dk", "")
        .replace("https://easyfood.dk", "");
    return url.toString();
};
